const bulkOperationsStyle = (theme) => ({
  root: {
    padding: theme.spacing(2)
  },
  actions: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    '& > * + *': {
      marginLeft: theme.spacing(2)
    }
  },
  actionIcon: {
    marginRight: theme.spacing(1),
    marginBottom: 2,
  }
});

export default bulkOperationsStyle;
